import AdForm from './ad-form';

export default AdForm;
